/**
 * Card Color Swatch Functionality
 * Handles color swatch interactions on product cards
 */

(function () {
  'use strict';

  function initCardColorSwatches() {
    const cardSwatchOverlays = document.querySelectorAll('.card__color-swatch-overlay:not([data-swatch-initialized])');

    if (cardSwatchOverlays.length === 0) {
      return;
    }

    cardSwatchOverlays.forEach(function (overlay) {
      overlay.setAttribute('data-swatch-initialized', 'true');
      const cardId = overlay.getAttribute('data-card-id');
      const swatchList = overlay.querySelector('.card__color-swatch-list');
      const swatchLinks = overlay.querySelectorAll('.card__color-swatch-link');

      // Enable drag-to-scroll functionality
      if (swatchList) {
        let isDown = false;
        let startX;
        let scrollLeft;

        swatchList.addEventListener('mousedown', function (e) {
          isDown = true;
          swatchList.style.cursor = 'grabbing';
          startX = e.pageX - swatchList.offsetLeft;
          scrollLeft = swatchList.scrollLeft;
        });

        swatchList.addEventListener('mouseleave', function () {
          isDown = false;
          swatchList.style.cursor = 'grab';
        });

        swatchList.addEventListener('mouseup', function () {
          isDown = false;
          swatchList.style.cursor = 'grab';
        });

        swatchList.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - swatchList.offsetLeft;
          const walk = (x - startX) * 2; // Scroll speed multiplier
          swatchList.scrollLeft = scrollLeft - walk;
        });

        // Touch support for mobile
        let touchStartX = 0;
        let touchScrollLeft = 0;

        swatchList.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.touches[0].pageX - swatchList.offsetLeft;
            touchScrollLeft = swatchList.scrollLeft;
          },
          { passive: true }
        );

        swatchList.addEventListener(
          'touchmove',
          function (e) {
            if (e.target.closest('.card__color-swatch-link')) {
              // Allow click on swatch items
              return;
            }
            const x = e.touches[0].pageX - swatchList.offsetLeft;
            const walk = (x - touchStartX) * 2;
            swatchList.scrollLeft = touchScrollLeft - walk;
          },
          { passive: true }
        );
      }

      // Ensure active state is visible on load (WITHOUT scrolling page)
      const activeItem = overlay.querySelector('.color-swatch__item.active');
      if (activeItem) {
        // Force the active state to be visible
        const activeLink = activeItem.querySelector('.card__color-swatch-link');
        if (activeLink) {
          activeLink.style.borderBottom = '2px solid #000';
        }

        // Scroll to active item inside swatchList only (no body scroll, no smooth)
        if (swatchList) {
          const itemRect = activeItem.getBoundingClientRect();
          const listRect = swatchList.getBoundingClientRect();
          const offset = itemRect.left - listRect.left;
          const scrollTarget = offset - listRect.width / 2 + itemRect.width / 2;

          // Instant horizontal scroll on the list element
          swatchList.scrollLeft += scrollTarget;
        }
      }

      swatchLinks.forEach(function (swatchLink) {
        swatchLink.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const swatchItem = this.closest('.color-swatch__item');
          // Check if it's a product or collection
          const productUrl = swatchItem.getAttribute('data-product-url');
          const collectionUrl = swatchItem.getAttribute('data-collection-url');
          const targetUrl = productUrl || collectionUrl;

          const imageSrcset = this.getAttribute('data-image-srcset');
          const imageSrc = this.getAttribute('data-image-src');
          const imageSizes = this.getAttribute('data-image-sizes');
          const secondaryImageSrcset = this.getAttribute('data-secondary-image-srcset');
          const secondaryImageSrc = this.getAttribute('data-secondary-image-src');

          // Update product/collection image
          const cardImage = document.querySelector(`#card-image-${cardId}`);
          // For collection cards, cardId is "collection-{id}", so we need to find image with id "card-collection-image-{id}"
          const collectionId = cardId.replace('collection-', '');
          const cardCollectionImage = document.querySelector(`#card-collection-image-${collectionId}`);
          const imageElement = cardImage || cardCollectionImage;

          console.log('productUrl', productUrl);
          console.log('collectionUrl', collectionUrl);
          console.log('targetUrl', targetUrl);
          console.log('imageSrcset', imageSrcset);
          console.log('imageSrc', imageSrc);
          console.log('imageSizes', imageSizes);
          console.log('cardImage', cardImage);
          console.log('collectionId', collectionId);
          console.log('cardCollectionImage', cardCollectionImage);
          console.log('imageElement', imageElement);

          if (imageElement) {
            if (imageSrcset) imageElement.setAttribute('srcset', imageSrcset);
            if (imageSrc) imageElement.setAttribute('src', imageSrc);
            console.log('SRC', imageSrc);
            if (imageSizes) {
              imageElement.setAttribute('sizes', imageSizes);
            }
          }

          // Update secondary image if it exists and secondary image data is available
          if (secondaryImageSrcset && secondaryImageSrc) {
            const secondaryImageElement = document.querySelector(`#card-secondary-image-${cardId}`);
            if (secondaryImageElement) {
              secondaryImageElement.setAttribute('srcset', secondaryImageSrcset);
              secondaryImageElement.setAttribute('src', secondaryImageSrc);
              console.log('Secondary SRC', secondaryImageSrc);
            }
          }

          // Update all card links (both product and collection)
          const cardLinks = document.querySelectorAll(`[data-card-link="${cardId}"]`);
          cardLinks.forEach(function (link) {
            if (targetUrl) {
              link.setAttribute('href', targetUrl);
            }
          });

          // Update active state
          const allSwatchItems = overlay.querySelectorAll('.color-swatch__item');
          allSwatchItems.forEach(function (item) {
            item.classList.remove('active');
            const link = item.querySelector('.card__color-swatch-link');
            if (link) {
              link.style.borderBottom = '2px solid transparent';
            }
          });
          swatchItem.classList.add('active');
          const newActiveLink = swatchItem.querySelector('.card__color-swatch-link');
          if (newActiveLink) {
            newActiveLink.style.borderBottom = '2px solid #000';
          }
        });
      });
    });
  }

  // Expose it so scripts that inject product cards (infinite scroll) can re-init
  window.initCardColorSwatches = initCardColorSwatches;

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardColorSwatches);
  } else {
    initCardColorSwatches();
  }

  // Re-initialize for dynamically loaded content in theme editor
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCardColorSwatches);
  }
})();
